import React from 'react';
import Layout from '../components/layout';
import ProjectsSlider from '../components/sections/ProjectsSlider/ProjectsSlider';

const Projects = () =>
    <Layout pageTitle="My Projects">
        <ProjectsSlider />
    </Layout>;

export default Projects;